module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('y-shelf', {
    attrs: {
      "title": _vm.t_data.base.title
    }
  }, [_c('div', {
    staticClass: "floors",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, _vm._l((_vm.t_data.data), function(item, j) {
    return _c('mall-goods', {
      key: j,
      attrs: {
        "msg": item,
        "showBtn": _vm.showBtn,
        "usage": _vm.usage,
        "showBrief": _vm.showBrief
      }
    })
  }), 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-427fb210","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/plugins/goodsGrid.vue
// module id = 794
// module chunks = 0 1 3